export default "__VITE_ASSET__gJGDHS$J__"